export default "__VITE_ASSET__42dc0024__"